import { render, staticRenderFns } from "./selectable-item.vue?vue&type=template&id=53c2f04c&"
import script from "./selectable-item.vue?vue&type=script&lang=js&"
export * from "./selectable-item.vue?vue&type=script&lang=js&"
import style0 from "./selectable-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports